module.exports = __webpack_public_path__ + "media/images/invoice-template-standard-0c2e9578365d9e3ad4e415597aabf728.png";